import { SafeHtml } from '@angular/platform-browser';

export enum IconSvgName {
  accessibilityOptions = 'accessibility-options',
  add = 'add',
  addNote = 'add-note',
  apple = 'apple',
  arrowDown = 'arrow-down',
  arrowLeft = 'arrow-left',
  arrowRight = 'arrow-right',
  arrowUp = 'arrow-up',
  attach = 'attach',
  award = 'award',
  backpack = 'backpack',
  balance = 'balance',
  banknote = 'banknote',
  bed = 'bed',
  bot = 'bot',
  breakfast = 'breakfast',
  briefcase = 'briefcase',
  calendar = 'calendar',
  calendarCheck = 'calendar-check',
  camera = 'camera',
  cancel = 'cancel',
  carretDown = 'carret-down',
  carretLeft = 'carret-left',
  carretRight = 'carret-right',
  carretUp = 'carret-up',
  chartBar = 'chart-bar',
  checkIn = 'check-in',
  checkOut = 'check-out',
  checkmark = 'checkmark',
  checkmarkOutline = 'checkmark-outline',
  chevronDown = 'chevron-down',
  chevronLeft = 'chevron-left',
  chevronRight = 'chevron-right',
  chevronUp = 'chevron-up',
  clipboard = 'clipboard',
  close = 'close',
  collapse = 'collapse',
  company = 'company',
  connectionError = 'connection-error',
  copy = 'copy',
  corpayRate = 'corpay-rate',
  creditCard = 'credit-card',
  crop = 'crop',
  dashboard = 'dashboard',
  delete = 'delete',
  divideCircle = 'divide-circle',
  divideSquare = 'divide-square',
  doorClosed = 'door-closed',
  dropdownList = 'dropdown-list',
  edit = 'edit',
  email = 'email',
  emergency = 'emergency',
  entertainment = 'entertainment',
  exclamationMark = 'exclamation-mark',
  exit = 'exit',
  expand = 'expand',
  export = 'export',
  facebook = 'facebook',
  filter = 'filter',
  freeText = 'free-text',
  gear = 'gear',
  generateEmail = 'generate-email',
  group = 'group',
  gym = 'gym',
  hide = 'hide',
  history = 'history',
  hotel = 'hotel',
  hotelHistory = 'hotel-history',
  import = 'import',
  info = 'info',
  invoce = 'invoce',
  leaf = 'leaf',
  list = 'list',
  linkedin = 'linkedin',
  loadingSpinner = 'loading-spinner',
  mail = 'mail',
  map = 'map',
  manager = 'manager',
  managed = 'managed',
  meal = 'meal',
  mealAllowances = 'meal-allowances',
  meetingVenue = 'meeting-venue',
  menu = 'menu',
  menuAction = 'menu-action',
  messageChat = 'message-chat',
  minus = 'minus',
  paginationFirst = 'pagination-first',
  paginationLast = 'pagination-last',
  parking = 'parking',
  password = 'password',
  payment = 'payment',
  personalDetails = 'personal-details',
  pin = 'pin',
  placeholderTable = 'placeholder-table',
  popularFilters = 'popular-filters',
  print = 'print',
  questionMark = 'question-mark',
  rate = 'rx-rate',
  rearrange = 'rearrange',
  receipt = 'receipt',
  reconciliationScore = 'reconciliation-score',
  refresh = 'refresh',
  reminder = 'reminder',
  resize = 'resize',
  roomexRate = 'roomex-rate',
  rowDensityCompact = 'row-density-compact',
  rowDensityMedium = 'row-density-medium',
  rowDensitySpacious = 'row-density-spacious',
  saverPlus = 'saver-plus',
  savings = 'savings',
  search = 'search',
  security = 'security',
  share = 'share',
  show = 'show',
  singleBed = 'single-bed',
  sort = 'sort',
  sortAsc = 'sort-asc',
  sortDesc = 'sort-desc',
  sortAz = 'sort-az',
  sortZa = 'sort-za',
  star = 'star',
  starOutline = 'star-outline',
  supplier = 'supplier',
  support = 'support',
  swimmingPool = 'swimming-pool',
  thunder = 'thunder',
  timeline = 'timeline',
  topUp = 'top-up',
  totalSpend = 'total-spend',
  train = 'train',
  travel = 'travel',
  twitter = 'twitter',
  user = 'user',
  users = 'users',
  userDetails = 'user-details',
  wallet = 'wallet',
  wifi = 'wifi',
  workerCog = 'worker-cog',
  workforce = 'workforce',
  workforceTracker = 'workforce-tracker',
}

export enum IconSvgSize {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}

export enum IconSvgColor {
  blueDark = 'blue-dark',
  greenDarker = 'green-darker',
  greyDarker = 'grey-darker',
  greyDark = 'grey-dark',
  grey = 'grey',
  greyLight = 'grey-light',
  greyLighter = 'grey-lighter',
  white = 'white',
  black = 'black',
  teal = 'teal',
  tealLight = 'teal-light',
  tealLighter = 'teal-lighter',
  tealDark = 'teal-dark',
  tealDarker = 'teal-darker',
  red = 'red',
  redLight = 'red-light',
  redLighter = 'red-lighter',
  redDark = 'red-dark',
  redDarker = 'red-darker',
  yellow = 'yellow',
  yellowLight = 'yellow-light',
  yellowLighter = 'yellow-lighter',
  yellowDark = 'yellow-dark',
  yellowDarker = 'yellow-darker',
  transparent = 'transparent',
  none = 'none',
  textColor = 'text-color',
  plumDarker = 'plum-darker',
}

export interface IconsCached {
  lastUpdate: Date;
  [key: string]: SafeHtml;
}
